import React from "react";
import { CategoryChart } from "../processors";

import { TableKpiProvider } from "../categoryChartQueryFns";
import { ReportingTableProviders } from "./ReportingTableProviders";

interface ReportingTableProviderProps extends TableKpiProvider {
    categoryChart: CategoryChart;
}
export const ReportingTableProvider: React.FC<ReportingTableProviderProps> = ({
    title,
    footer,
    vis,
    categoryChart
}) => {
    return <ReportingTableProviders categoryChart={categoryChart} vis={vis} footer={footer} title={title} />;
};
